import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   width: 100%;
   height: 360px;
   overflow: auto;
   padding-right: 15px;

   .action {
      margin-bottom: 12px;
   }

   .sectionCard {
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      background: #fff;
      overflow: hidden;
      margin-bottom: 12px;
   }

   .sectionToggle {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: none;
      background: #f8fafc;
      color: #111827;
      padding: 10px 12px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      text-align: left;
   }

   .sectionToggleIcon {
      font-size: 16px;
      line-height: 1;
      color: #6b7280;
      margin-left: 8px;
   }

   .toolbar {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
   }

   .generateBtn {
      border: none;
      border-radius: 6px;
      padding: 8px 12px;
      background: #0f766e;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
   }

   .generateBtn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
   }

   .webhookPanelBody {
      padding: 10px;
      background: #f8fafc;
      display: flex;
      flex-direction: column;
      gap: 10px;
   }

   .webhookGroup {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      background: #ffffff;
      padding: 10px;
   }

   .groupTitle {
      font-size: 12px;
      font-weight: 700;
      color: #334155;
      letter-spacing: 0.02em;
      margin-bottom: 8px;
      text-transform: uppercase;
   }

   .link-container {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px;
      background: #f9f9f9;
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
   }

   .link-with-copy {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
   }

   .copy-icon {
      color: #666;
      font-size: 12px;
      flex-shrink: 0;
   }

   .copy-icon.copied {
      color: #10b981;
   }

   .link-text {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 13px;
      color: #333;
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
      min-width: 0;
      flex: 1;
   }

   .secret-hint {
      color: #4b5563;
      font-size: 12px;
      margin-bottom: 6px;
      line-height: 1.4;
   }

   .secret-input {
      width: 100%;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      padding: 8px 10px;
      font-size: 13px;
      margin-bottom: 8px;
      outline: none;
      box-sizing: border-box;
   }

   .secret-input:focus {
      border-color: #0f766e;
      box-shadow: 0 0 0 1px #0f766e;
   }

   .warning {
      color: #92400e;
      background: #fef3c7;
      border: 1px solid #fcd34d;
      border-radius: 6px;
      padding: 8px 10px;
      font-size: 12px;
      line-height: 1.45;
      margin-bottom: 10px;
   }

   .error {
      color: #991b1b;
      background: #fee2e2;
      border: 1px solid #fca5a5;
      border-radius: 6px;
      padding: 8px 10px;
      font-size: 12px;
      line-height: 1.45;
      margin-bottom: 10px;
   }
`;

export const Loader = styled.div`
   width: 32px;
   height: 32px;
   border: 3px solid #d1fae5;
   border-top-color: #0f766e;
   border-radius: 50%;
   animation: spin 0.8s linear infinite;
   margin: 40px auto;

   @keyframes spin {
      to {
         transform: rotate(360deg);
      }
   }
`;
